export default __webpack_public_path__ + "static/media/else_2_lowdef.fe186dc9.png";